module.exports = "/shared/fonts/helvetica-condensed-black.otf";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/helvetica-condensed-black.otf
// module id = 319
// module chunks = 13